// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2OWHD","errorLogs":"EditorFooter_errorLogs__3wD2j"};